import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { NamedView, ViewType } from "@common/types/views/views";
import { FilterTabs } from "@components/pageHeader/filters/lib";

export const BILLABLE_EXPENSE_DRILL_DOWN_AVAILABLE_FILTERS: FilterTabs[] = [
    FilterTabs.DATE,
    FilterTabs.CATEGORY,
    FilterTabs.ACCOUNT,
    FilterTabs.AMOUNT,
];

// Opened from the counterparty directory's "Billable expenses" column: the
// drawer is pre-filtered to a single billable customer (transaction.customerId),
// so the Customer column is shown instead of exposing it as a filter tab.
export const DefaultBillableExpenseDrillDownTransactionView: NamedView<TransactionView> =
    {
        id: "billable-expense-drilldown",
        name: "Billable expenses drilldown",
        type: ViewType.TRANSACTION,
        options: {
            bulkActions: true,
            selection: true,
        },
        filters: {},
        columns: [
            { id: TransactionColumn.LOCK, options: { pin: "left" } },
            { id: TransactionColumn.DATE, options: { pin: "left" } },
            { id: TransactionColumn.SPLIT, options: { pin: "left" } },
            { id: TransactionColumn.BANK_DESCRIPTION },
            { id: TransactionColumn.COUNTERPARTY },
            { id: TransactionColumn.CUSTOMER },
            { id: TransactionColumn.CATEGORY },
            { id: TransactionColumn.ACCOUNT },
            {
                id: TransactionColumn.AMOUNT,
                options: { pin: "right" },
            },
            {
                id: TransactionColumn.ENTITY,
                options: { pin: "right" },
            },
        ],
    };
